import type { RequestConfig } from '@customTypes/index';
import type { WorkDto, WorkInviteItemDto } from '@customTypes/types';

import { api } from '@/shared/api/instance';

export type CreateWorkInviteParams = RequestConfig<WorkDto>;

export const createWorkInvite = async ({
  params,
  config
}: CreateWorkInviteParams) =>
  api.post<WorkInviteItemDto>(`/api/work/invites`, params, config);
